module.exports = __webpack_public_path__ + "static/img/322.1761817.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200608/322.jpg
// module id = Q79w
// module chunks = 0